<template>
  <circle cx="50%" cy="50%" r="50%" />
  <path
    d="m4.12656 8.4675C4.03521 8.5739 3.99075 8.70937 4.0016 8.84938C4.01246 8.98939 4.07686 9.1168 4.18362 9.20781L6.77488 11.4291C6.87114 11.5113 6.9905 11.5554 7.11581 11.5554C7.13121 11.5554 7.14696 11.5547 7.16271 11.5533C7.30447 11.5407 7.43223 11.4732 7.52254 11.3636L11.9546 5.96934C12.0435 5.86084 12.0852 5.72432 12.0715 5.58466C12.0575 5.445 11.9907 5.31899 11.8821 5.22973L11.0708 4.56328C10.8471 4.37987 10.516 4.41207 10.3319 4.63574L6.92084 8.78742L5.55013 7.61308C5.33031 7.42546 4.99849 7.45031 4.80982 7.67013L4.12656 8.4675Z"
    fill="white"
  />
</template>
